export const videos = [
  {
    id: '1',
    title: 'Kitten Discovers Mirror for First Time',
    youtubeId: 'cMB7gcTTBiA',
    thumbnail: 'https://img.youtube.com/vi/cMB7gcTTBiA/mqdefault.jpg',
    category: 'funny',
    views: 2847392,
    likes: 89234,
    uploadDate: '2024-01-15',
    description: 'Watch this adorable kitten\'s hilarious reaction when meeting their reflection for the very first time!'
  },
  {
    id: '2',
    title: 'Funniest Cats — Awesome Funny Cat Videos',
    youtubeId: 'J---aiyznGQ',
    thumbnail: 'https://img.youtube.com/vi/J---aiyznGQ/mqdefault.jpg',
    category: 'compilation',
    views: 5234891,
    likes: 156789,
    uploadDate: '2024-02-01',
    description: 'The ultimate collection of funny cat moments that will make you laugh out loud!'
  },
  {
    id: '3',
    title: 'Rescue Kitten Transformation — 6 Month Journey',
    youtubeId: 'OtRRUEs9uyc',
    thumbnail: 'https://img.youtube.com/vi/OtRRUEs9uyc/mqdefault.jpg',
    category: 'rescue',
    views: 1892456,
    likes: 67234,
    uploadDate: '2024-01-20',
    description: 'Heartwarming transformation of a rescue kitten from scared to confident over 6 months.'
  },
  {
    id: '4',
    title: 'Understanding Cat Body Language',
    youtubeId: 'sdrFNFMcXpE',
    thumbnail: 'https://img.youtube.com/vi/sdrFNFMcXpE/mqdefault.jpg',
    category: 'educational',
    views: 987234,
    likes: 34567,
    uploadDate: '2024-01-10',
    description: 'Learn to read your cat\'s body language and understand what they\'re trying to tell you.'
  },
  {
    id: '5',
    title: 'Cute Kittens Sleeping — Adorable Compilation',
    youtubeId: 'W86cTIoMv2U',
    thumbnail: 'https://img.youtube.com/vi/W86cTIoMv2U/mqdefault.jpg',
    category: 'cute',
    views: 3456789,
    likes: 123456,
    uploadDate: '2024-02-05',
    description: 'The cutest compilation of sleepy kittens you\'ll ever see!'
  },
  {
    id: '6',
    title: 'Cats Being Dramatic — Hilarious Fails',
    youtubeId: 'dX3k_QDnzHE',
    thumbnail: 'https://img.youtube.com/vi/dX3k_QDnzHE/mqdefault.jpg',
    category: 'funny',
    views: 4123567,
    likes: 145678,
    uploadDate: '2024-01-25',
    description: 'Cats attempting jumps and failing in the most hilarious ways!'
  },
  {
    id: '7',
    title: 'How to Trim Your Cat\'s Nails Safely',
    youtubeId: 'o1XeXgmzKIk',
    thumbnail: 'https://img.youtube.com/vi/o1XeXgmzKIk/mqdefault.jpg',
    category: 'educational',
    views: 756234,
    likes: 28934,
    uploadDate: '2024-01-12',
    description: 'Step-by-step guide to safely trimming your cat\'s nails at home without stress.'
  },
  {
    id: '8',
    title: 'Tiny Kitten Playing with Toys for the First Time',
    youtubeId: 'Mq9FBBhFMHo',
    thumbnail: 'https://img.youtube.com/vi/Mq9FBBhFMHo/mqdefault.jpg',
    category: 'cute',
    views: 2987456,
    likes: 98765,
    uploadDate: '2024-02-08',
    description: 'Adorable tiny kitten discovering and playing with toys for the first time!'
  },
  {
    id: '9',
    title: 'Street Cat Rescue — Before and After',
    youtubeId: 'Vw6cdpD89Gg',
    thumbnail: 'https://img.youtube.com/vi/Vw6cdpD89Gg/mqdefault.jpg',
    category: 'rescue',
    views: 1567890,
    likes: 56789,
    uploadDate: '2024-01-18',
    description: 'Amazing transformation of a street cat after being rescued and given proper care and love.'
  },
  {
    id: '10',
    title: 'Cats Being Jerks — Ultimate Compilation',
    youtubeId: 'OdFkjD_CtGU',
    thumbnail: 'https://img.youtube.com/vi/OdFkjD_CtGU/mqdefault.jpg',
    category: 'funny',
    views: 6234567,
    likes: 189234,
    uploadDate: '2024-02-10',
    description: 'Hilarious compilation of cats being absolute jerks to their owners and dogs!'
  },
  {
    id: '11',
    title: 'Ultimate Cat Compilation — Best of 2024',
    youtubeId: 'tLt5rBfNucc',
    thumbnail: 'https://img.youtube.com/vi/tLt5rBfNucc/mqdefault.jpg',
    category: 'compilation',
    views: 7891234,
    likes: 234567,
    uploadDate: '2024-02-12',
    description: 'The best cat moments from 2024 all in one epic compilation!'
  },
  {
    id: '12',
    title: 'Newborn Kittens — First Week of Life',
    youtubeId: 'jRHQPG1xd9g',
    thumbnail: 'https://img.youtube.com/vi/jRHQPG1xd9g/mqdefault.jpg',
    category: 'cute',
    views: 2345678,
    likes: 87654,
    uploadDate: '2024-02-03',
    description: 'Watch these precious newborn kittens grow during their first week of life!'
  },
  {
    id: '13',
    title: 'Cat Training 101 — Basic Commands',
    youtubeId: 'VrnMZGc-dHE',
    thumbnail: 'https://img.youtube.com/vi/VrnMZGc-dHE/mqdefault.jpg',
    category: 'educational',
    views: 892345,
    likes: 32145,
    uploadDate: '2024-01-22',
    description: 'Yes, you can train your cat! Learn basic commands and tricks to teach your feline friend.'
  },
  {
    id: '14',
    title: 'Cats vs Cucumbers — Funniest Reactions',
    youtubeId: 'HTgYVg3cDG4',
    thumbnail: 'https://img.youtube.com/vi/HTgYVg3cDG4/mqdefault.jpg',
    category: 'funny',
    views: 5678901,
    likes: 167890,
    uploadDate: '2024-01-28',
    description: 'Watch cats\' hilarious reactions when they encounter cucumbers placed behind them!'
  },
  {
    id: '15',
    title: 'Feral Cat Colony Rescue Mission',
    youtubeId: 'NNZiBUOJWIA',
    thumbnail: 'https://img.youtube.com/vi/NNZiBUOJWIA/mqdefault.jpg',
    category: 'rescue',
    views: 1234567,
    likes: 45678,
    uploadDate: '2024-01-30',
    description: 'Follow along as rescuers help an entire feral cat colony find safety and care.'
  },
  {
    id: '16',
    title: 'Fluffy Kittens Cuddling Together',
    youtubeId: 'lGOofzZOyl8',
    thumbnail: 'https://img.youtube.com/vi/lGOofzZOyl8/mqdefault.jpg',
    category: 'cute',
    views: 4567890,
    likes: 145678,
    uploadDate: '2024-02-07',
    description: 'Pure cuteness overload — fluffy kittens cuddling and sleeping together!'
  },
  {
    id: '17',
    title: 'Best Cat Videos of All Time',
    youtubeId: 'GbIRUw_J4-E',
    thumbnail: 'https://img.youtube.com/vi/GbIRUw_J4-E/mqdefault.jpg',
    category: 'compilation',
    views: 9876543,
    likes: 298765,
    uploadDate: '2024-02-14',
    description: 'The most popular and beloved cat videos from across the internet, all in one place!'
  },
  {
    id: '18',
    title: 'Understanding Cat Nutrition',
    youtubeId: 'PSdYdHaHN8E',
    thumbnail: 'https://img.youtube.com/vi/PSdYdHaHN8E/mqdefault.jpg',
    category: 'educational',
    views: 678901,
    likes: 25678,
    uploadDate: '2024-01-16',
    description: 'Everything you need to know about proper cat nutrition and feeding schedules.'
  },
  {
    id: '19',
    title: 'Abandoned Kitten Rescue — Heartwarming Story',
    youtubeId: '6mOcNbLXhqk',
    thumbnail: 'https://img.youtube.com/vi/6mOcNbLXhqk/mqdefault.jpg',
    category: 'rescue',
    views: 1789012,
    likes: 62345,
    uploadDate: '2024-02-02',
    description: 'Heartwarming story of an abandoned kitten being rescued and finding a forever home.'
  },
  {
    id: '20',
    title: 'Cats Doing Funny Things — Laugh Guaranteed',
    youtubeId: 'RFMuw3xpmFE',
    thumbnail: 'https://img.youtube.com/vi/RFMuw3xpmFE/mqdefault.jpg',
    category: 'funny',
    views: 5432109,
    likes: 178901,
    uploadDate: '2024-02-11',
    description: 'A collection of cats doing the most random and funny things you\'ve ever seen!'
  }
];

export const trendingVideos = [
  {
    id: 't1',
    title: 'Cats vs Cucumbers — Funniest Reactions',
    youtubeId: 'cMB7gcTTBiA',
    thumbnail: 'https://img.youtube.com/vi/cMB7gcTTBiA/mqdefault.jpg',
    views: 2847392,
    uploadDate: '2024-01-15'
  },
  {
    id: 't2',
    title: 'Funniest Cats Compilation 2024',
    youtubeId: 'J---aiyznGQ',
    thumbnail: 'https://img.youtube.com/vi/J---aiyznGQ/mqdefault.jpg',
    views: 5234891,
    uploadDate: '2024-02-01'
  },
  {
    id: 't3',
    title: 'Rescue Kitten Transformation',
    youtubeId: 'OtRRUEs9uyc',
    thumbnail: 'https://img.youtube.com/vi/OtRRUEs9uyc/mqdefault.jpg',
    views: 1892456,
    uploadDate: '2024-01-20'
  },
  {
    id: 't4',
    title: 'Cute Kittens Sleeping Compilation',
    youtubeId: 'W86cTIoMv2U',
    thumbnail: 'https://img.youtube.com/vi/W86cTIoMv2U/mqdefault.jpg',
    views: 3456789,
    uploadDate: '2024-02-05'
  }
];

export const infiniteVideos = [
  {
    id: 'inf1',
    title: 'Cats Being Dramatic — Hilarious Fails',
    youtubeId: 'dX3k_QDnzHE',
    thumbnail: 'https://img.youtube.com/vi/dX3k_QDnzHE/mqdefault.jpg',
    views: 4123567,
    likes: 145678
  },
  {
    id: 'inf2',
    title: 'Tiny Kitten Playing with Toys',
    youtubeId: 'Mq9FBBhFMHo',
    thumbnail: 'https://img.youtube.com/vi/Mq9FBBhFMHo/mqdefault.jpg',
    views: 2987456,
    likes: 98765
  },
  {
    id: 'inf3',
    title: 'Cats Being Jerks Compilation',
    youtubeId: 'OdFkjD_CtGU',
    thumbnail: 'https://img.youtube.com/vi/OdFkjD_CtGU/mqdefault.jpg',
    views: 6234567,
    likes: 189234
  },
  {
    id: 'inf4',
    title: 'Newborn Kittens First Week',
    youtubeId: 'jRHQPG1xd9g',
    thumbnail: 'https://img.youtube.com/vi/jRHQPG1xd9g/mqdefault.jpg',
    views: 2345678,
    likes: 87654
  },
  {
    id: 'inf5',
    title: 'Cat Slaps Dog Every Time It Moves',
    youtubeId: 'HTgYVg3cDG4',
    thumbnail: 'https://img.youtube.com/vi/HTgYVg3cDG4/mqdefault.jpg',
    views: 5678901,
    likes: 167890
  },
  {
    id: 'inf6',
    title: 'Fluffy Kittens Cuddling',
    youtubeId: 'lGOofzZOyl8',
    thumbnail: 'https://img.youtube.com/vi/lGOofzZOyl8/mqdefault.jpg',
    views: 4567890,
    likes: 145678
  }
];

export const categories = [
  {
    id: 'funny',
    name: 'Funny Cats',
    icon: '😹',
    videoCount: 156
  },
  {
    id: 'cute',
    name: 'Cute Kittens',
    icon: '😻',
    videoCount: 203
  },
  {
    id: 'educational',
    name: 'Cat Care',
    icon: '📚',
    videoCount: 89
  },
  {
    id: 'rescue',
    name: 'Rescue Stories',
    icon: '❤️',
    videoCount: 67
  },
  {
    id: 'compilation',
    name: 'Compilations',
    icon: '🎬',
    videoCount: 124
  }
];
